export default "__VITE_ASSET__CoZN0pGf__"